"use client";

import clsx from "clsx";

import Arrow from "@/assets/svg/32/Arrow";
import useScrollToTop from "@/lib/hooks/useScrollToTop";

import styles from "./scroll-to-top.module.css";

const ScrollToTop = (): React.JSX.Element => {
  const scrollToTop = useScrollToTop();

  return (
    <button
      type="button"
      className={clsx(styles["scroll-to-top"], "transparent")}
      onClick={scrollToTop}
    >
      <span className="sr-only">Tilbake til toppen</span>
      <Arrow />
    </button>
  );
};

export default ScrollToTop;
